"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HELP_ARTICLE_URLS = void 0;
const ROOT = 'https://help.medely.com';
const REFERRAL = 'https://help.medely.com/articles/374955-medely-referral-program';
const MEDELY_PROFESSIONALS = 'https://help.medely.com/collections/127398-medely-professionals';
const SIGNING_UP = 'https://help.medely.com/collections/127521-signing-up';
const BACKGROUND_CHECK_PENDING = 'https://help.medely.com/en/articles/3844099-why-is-my-background-check-still-pending';
const CANCELLATION_AND_NO_SHOW = 'https://help.medely.com/en/articles/1871897-professional-cancellation-policy';
const CANCELLATION_AND_NO_SHOW_AGENCY = 'https://help-partners.medely.com/en/articles/9151633-agency-staff-cancellation-policy';
const PARTNERS_HELP_CENTER = 'https://help-partners.medely.com/en/';
const COVID_REQUIREMENTS = 'https://help.medely.com/en/articles/5497289-covid-vaccine-booster-or-test-protocol-when-required-by-state-or-facility';
const COMMUNITY_GUIDELINES = 'https://help.medely.com/en/articles/8834479-facility-community-guidelines';
const SMS = 'https://help.medely.com/en/articles/5322046-sms-terms';
const PRIVACY_POLICY = 'https://medely.com/privacy-policy';
exports.HELP_ARTICLE_URLS = {
    ROOT,
    BACKGROUND_CHECK_PENDING,
    CANCELLATION_AND_NO_SHOW: (isAgency) => isAgency ? CANCELLATION_AND_NO_SHOW_AGENCY : CANCELLATION_AND_NO_SHOW,
    COMMUNITY_GUIDELINES,
    PARTNERS_HELP_CENTER,
    COVID_REQUIREMENTS,
    MEDELY_PROFESSIONALS,
    PRIVACY_POLICY,
    REFERRAL,
    SIGNING_UP,
    SMS,
};
